import VehicleEventsHtml from './templates/vehicle-events.html';

export function VehicleEventsDirective () {
  return {
    controller: 'VehicleEventsCtrl',
    restrict: 'E',
    templateUrl: VehicleEventsHtml,
    scope: {
      vehicle: '=',
      events: '=',
      customer: '='
    }
  }
}
